<template>
    <main class="c-app-content is-sidebar-tiny">
        <g-loading v-if="firstLoading" />
        <g-table v-else :filter="filterFormModel" :itemCount="itemCount" :items="items" :fields="fields" :isSearch='false' @load="load" @reset="reset"
                 title="Phân loại rác" titleIcon="fa fa-file-alt">
            <!-- <template slot="actionBefore">
                <b-tabs class="c-tabs-button mr-2" small pills @input="load">
                    <b-tab v-for="option in typeOptions" :key="option.value" :title="option.text + ' (' + (params.dataKeyword[option.value] ? params.dataKeyword[option.value] : '0') + ')'" @click="search(option.value)"></b-tab>
                </b-tabs>
            </template> -->
            <template slot="filter">
                <ward-select class="mr-2" :model="filterFormModel" attribute="ward_id" :multiple="false" :close-on-select='true' :filter="{did: 509}" @change="search"/>
                <time-range-picker class="mr-2" :model="filterFormModel" label="Ngày kiểm toán " fromAttribute="from_time_check" toAttribute="to_time_check" :defaultShortcut="10" @change="search" />
            </template>
            <template #cell(location)="{item}">
                <div v-if="item.ward_id && params.locations && params.locations[item.ward_id]">{{params.locations[item.ward_id].name}}</div>
            </template>
            <template #cell(day)="{item}">
                <span v-if="item.time_check">{{item.time_check * 1000 |  moment('DD/MM/YYYY')}} </span>
            </template>
            <template #cell(already)="{item}">
                <div ><span class="small text-gray-999">Số hộ: </span>{{ item.already }}</div>
                <div ><span class="small text-gray-999">Tỉ lệ: </span>{{ (item.already/item.total_house * 100).toFixed(2) }}%</div>
            </template>
            <template #cell(no)="{item}">
                <div ><span class="small text-gray-999">Số hộ: </span>{{ item.no }}</div>
                <div ><span class="small text-gray-999">Tỉ lệ: </span>{{ (item.no/item.total_house * 100).toFixed(2) }}%</div>
            </template>
            <template #cell(not_yet)="{item}">
                <div ><span class="small text-gray-999">Số hộ: </span>{{ item.not_yet }}</div>
                <div ><span class="small text-gray-999">Tỉ lệ: </span>{{ (item.not_yet/item.total_house * 100).toFixed(2) }}%</div>
            </template>
            <template slot="action">
                <g-button :loading="saveLoading" v-if="permissions('data-classify_create')"  size="sm" variant="success" icon="fa fa-plus" content="Thêm mới"  @click="create" />
            </template>
            <template #cell(action)="{item}">
                <g-button v-if="permissions('data-classify_update')"  :loading="updateLoading" size="sm" variant="outline-info" class="ml-1 mb-1" icon="pencil" @click="update(item.id)"  />
                <g-button v-if="permissions('data-classify_del')"  :loading="delLoading" size="sm" variant="outline-danger" class="ml-1 mb-1"   icon="trash-fill" @click='del(item.id)' />
            </template>
        </g-table>
        <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
            <ward-select label="Phường"  :required='true'  :model="formModel" attribute="ward_id" :multiple="false" :errors="formErrors" :close-on-select='true' :filter="{did: 509}" />
            <form-date-time label="Ngày kiểm soát"  :required='true' :model="formModel" :errors="formErrors" attribute="time_check" format="DD/MM/YYYY" placeholder="DD/MM/YYYY" />
            <form-input type="number" label="Số hộ có phân loại rác" :required='true' :model="formModel" attribute="already" :errors="formErrors"/>
            <form-input type="number" label="Số hộ không phân loại rác" :required='true' :model="formModel" attribute="no" :errors="formErrors"/>
            <form-input type="number" label="Số hộ chưa phân loại rác" :required='true' :model="formModel" attribute="not_yet" :errors="formErrors"/>

            <template v-slot:modal-footer="{ ok, cancel}">
                <b-button variant="secondary" class="float-right" @click="cancel">Đóng</b-button>
                <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="ok">
                    <b-spinner v-if="saveLoading" small></b-spinner>
                    <em v-else class="fa fa-save" ></em>
                    Lưu lại
                </b-button>
            </template>
        </b-modal>
    </main>
</template>

<script>
    import list from "@/mixins/List";
    import crud from '@/mixins/CRUD';
    import role from '@/mixins/Role';
    import WardSelect from '@/components/WardSelect';

    export default {
        components: {WardSelect},
        mixins: [list, crud, role],
        data: function () {
            return {
                reloadBus: "reloadKeyword",
                service: '/data-classify',
                fields: [
                    {key: 'location', label: "Phường", class: 'text-left'},
                    {key: 'day', label: "Ngày kiểm soát", class: 'text-left'},
                    {key: 'total_house', label: "Tổng số hộ", class: 'text-left'},
                    {key: 'already', label: "Có phân loại rác", class: 'text-left'},
                    {key: 'no', label: "Không phân loại rác", class: 'text-left'},
                    {key: 'not_yet', label: "Chưa phân loại rác", class: 'text-left'},
                    {key: 'action', label: "Hành động", class: 'text-right'},
                ],
                defaultFilterFormModel: {
                    keyword: null,
                    type: 1,
                    ward_id: null,
                    year: null,
                },
                defaultFormModel: {
                    already: 0,
                    no: 0,
                    not_yet: 0
                },
            }

        },
        methods: {
            search(val) {
                this.filterFormModel.type = val;
                this.load();
            },
            beforeUpdate(data) {
                data.time_check = data.time_check ? data.time_check * 1000 : null;
            },
        },
        mounted() {
            
        }
    }
</script>